function getAjaxBase() {
    const segments = window.location.pathname.split('/').filter(Boolean);
    return segments[0] === 'en' ? '/en' : '';
}

export default function initCartPage() {
    const cart = document.querySelector('.shopping-cart');
    if (!cart) return;

    const overlay = cart.querySelector('.shopping-cart-overlay');
    let sidebar = cart.querySelector('.shopping-cart-sidebar');
    const main = cart.querySelector('.shopping-cart-main');
    const nonce = cart.dataset.nonce || '';

    if (!main) return;

    let debounceTimer = null;

    const showOverlay = () => {
        if (overlay) overlay.classList.add('is-active');
    };

    const hideOverlay = () => {
        if (overlay) overlay.classList.remove('is-active');
    };

    const updateCartItem = async (cartItemKey, quantity) => {
        showOverlay();

        const body = new URLSearchParams();
        body.append('cart_item_key', cartItemKey);
        body.append('quantity', quantity);
        body.append('security', nonce);

        try {
            const response = await fetch(getAjaxBase() + '/?wc-ajax=cbdonna_update_cart', {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: body.toString(),
            });

            const data = await response.json();

            if (data && data.success) {
                if (data.data.sidebar_html) {
                    const newSidebar = document.createElement('div');
                    newSidebar.innerHTML = data.data.sidebar_html;
                    const newSidebarEl = newSidebar.querySelector('.shopping-cart-sidebar');
                    if (newSidebarEl && sidebar) {
                        sidebar.replaceWith(newSidebarEl);
                        sidebar = newSidebarEl;
                    }
                }

                if (data.data.item_key && data.data.item_total_html) {
                    const item = cart.querySelector(`[data-cart-item-key="${data.data.item_key}"]`);
                    if (item) {
                        const total = item.querySelector('.shopping-cart-item-total');
                        if (total) {
                            total.outerHTML = `<div class="shopping-cart-item-total">${data.data.item_total_html}</div>`;
                        }
                    }
                }

                const countEl = document.querySelector('.site-header-cart-count');
                if (countEl && data.data.cart_count !== undefined) {
                    countEl.textContent = data.data.cart_count;
                }
            }
        } catch (err) {
            // silent fail
        } finally {
            hideOverlay();
        }
    };

    const debouncedUpdate = (key, qty) => {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => {
            updateCartItem(key, qty);
        }, 300);
    };

    cart.addEventListener('change', (e) => {
        const select = e.target.closest('.shopping-cart-item-qty-select');
        if (!select) return;

        const item = select.closest('.shopping-cart-item');
        if (!item) return;

        const key = item.dataset.cartItemKey;
        const qty = parseInt(select.value, 10);

        if (!key || qty < 1) return;
        debouncedUpdate(key, qty);
    });

    cart.addEventListener('click', (e) => {
        const removeBtn = e.target.closest('.shopping-cart-item-remove');
        if (!removeBtn) return;

        e.preventDefault();

        const item = removeBtn.closest('.shopping-cart-item');
        const key = item ? item.dataset.cartItemKey : null;
        if (!key) return;

        const body = new URLSearchParams();
        body.append('cart_item_key', key);

        showOverlay();

        fetch(getAjaxBase() + '/?wc-ajax=remove_from_cart', {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: body.toString(),
        })
            .then((r) => r.json())
            .then((data) => {
                if (data && data.fragments) {
                    for (const [selector, html] of Object.entries(data.fragments)) {
                        if (selector === '.shopping-layer-content') {
                            const el = document.querySelector(selector);
                            if (el) el.innerHTML = html;
                        }
                    }
                }
                window.location.reload();
            })
            .catch(() => {
                window.location.reload();
            });
    });
}
